import { atom } from 'recoil';

export const setLabFetchData = atom({
    key: 'setLabFetchData', // unique ID (with respect to other atoms/selectors)
    default: [] // default value (aka initial value)
});  